import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Badge = styled.div(
  ({theme}) => css`
    float: right;
    width: 90px;
    margin-left: 16px;
    /* @FIXME should be set in the toolkit component */
    font-family: ${theme.fontFamily};

    ${theme.respondTo(
      'md',
      css`
        width: 126px;
      `
    )}

    ${theme.respondTo(
      'lg',
      css`
        width: 150px;
      `
    )}
  `
);
